import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { ViewContentType } from '../models/ContentTypes';
import { IViewBase } from '../models/IViewInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Views } from '../resources/Views';
import { IChangeContentTagsAction, IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { IErrorDetail, INotificationTranslationIds } from './ContentActionNotification';
import { ContentUrlForItem } from './ContentUrl';

export class ChangeViewsTagsAction implements IChangeContentTagsAction {

  public static notificationTranslationIds: INotificationTranslationIds = {
    successId: 'changeTagsViewsSuccess',
    errorId: 'changeTagsViewsError'
  };

  public execute: (itemSet: Set<IViewBase>, actionContext: IActionContext) => ng.IPromise<IChangeContentTagsResult>;

  public static $inject = ['ChangeTagsActionHelperService', '$translate', 'Views'];

  constructor(
    private ChangeTagsActionHelper: ChangeTagsActionHelperService,
    private $translate: ng.translate.ITranslateService,
    private Views: Views,
  ) {
    /*
     changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => ng.IPromise<IResult>;
     getDescription: (itemSet: Set<T>) => string;
     notificationIds: INotificationTranslationIds;
     errorDetailFn: (errorItem: IErrorItem<T>) => IErrorDetail;
     */
    this.execute = ChangeTagsActionHelper.createExecuteFn<IViewBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => this.Views.changeTags(ids, addTags, removeTags),
      getDescription: (views: Set<IViewBase>) => this.getDescription(views),
      notificationIds: ChangeViewsTagsAction.notificationTranslationIds,
      errorDetailFn: (errorItem: IErrorItem<IViewBase>) => this.changeTagsErrorDetail(errorItem)
    });
  }

  private getDescription(views: Set<IViewBase>) {
    return (views.size() === 1)
      ? this.$translate.instant('changeTagsViewDescription', { NAME: L10n.elideIfLong(views.first().name) })
      : this.$translate.instant('changeTagsViewsDescription', { COUNT: views.size() }, L10n.Interpolations.Count);
  }

  public changeTagsErrorDetail(errorItem: IErrorItem<IViewBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, ViewContentType),
      errorMessage: this.ChangeTagsActionHelper.errorMessageFor(errorItem)
    };
  }

}

Module.instance().service('ChangeViewsTagsAction', ChangeViewsTagsAction);
